import React from 'react';
import { RoleAiMarketplace } from '@/components/ai/RoleAiMarketplace';

/**
 * Coach AI Tools Marketplace
 * Coaches have 6 tool slots: 3 AI (creative) + 3 SmartBlock (trackers)
 */
export default function CoachAiMarketplace() {
  return (
    <div className="mx-auto max-w-5xl">
      <RoleAiMarketplace
        role="coach"
        title="AI Tools Marketplace"
        description="Equip your locker room with AI tools for practice planning and recruiting, plus SmartBlock trackers for athlete performance and team efficiency diagnostics."
      />
    </div>
  );
}
